import React, { useEffect } from "react"
import { injectIntl } from "gatsby-plugin-intl"
import { CalculateDiscount } from "@tmu/components/common"
import { getQueryParams } from "@tmu/utils/string"
import { useFooterType } from "@tmu/hooks"
import { FOOTER_TYPE } from "@tmu/apollo/constants"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  StyledBackButton,
  StyledContent,
  StyledPageContainer,
} from "@tmu/global/page-addons/calculate-page.styles"
import {
  getCredentials,
  isBrowser,
  isTokenExpired,
  navigateIfNotAuthenticated,
} from "@tmu/utils/auth"
import { get } from "@tmu/utils/storage"
import { navigate } from "gatsby-plugin-intl"

const Calculate = () => {
  const params = getQueryParams()
  useFooterType({ footerType: FOOTER_TYPE.HIDE })

  const { expired } = getCredentials()

  const redirectUrl = isBrowser
    ? window?.location?.pathname + window?.location?.search
    : "/"

  useEffect(() => {
    if (expired) {
      navigateIfNotAuthenticated(redirectUrl)
    }
  }, [expired])

  return (
    <>
      <StyledPageContainer>
        <StyledContent>
          <StyledBackButton
            onClick={() => {
              history.back()
            }}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </StyledBackButton>
          <CalculateDiscount slug={params?.slug} />
        </StyledContent>
      </StyledPageContainer>
    </>
  )
}

export default injectIntl(Calculate)
